export const NONE = '0';
export const TOP_BIG = '24px 0 0';
export const RIGHT_NORMAL = '0 8px 0 0';
export const LEFT_NORMAL = '0 0 0 8px';
export const BOTTOM_NORMAL = '0 0 8px';
export const BOTTOM_MED = '0 0 16px';
export const BOTTOM_BIG = '0 0 24px';
